// extracted by mini-css-extract-plugin
export default {"config":"Config_config__IUy48","form":"Config_form__xr29F","callout":"Config_callout__RszZ5"};